<template>
  <form action="#">
    <div class="container container--max-750">
      <h1 class="mb-5">
        {{ $t("lang.label_index_message") }}
      </h1>
      <b-row>
        <b-form-group class="col-sm">
          <div class="position-relative">
            <b-form-input class="form-control form-control-lg" id="email" type="email" v-model="email" :placeholder="$t('lang.label_email')" aria-describedby=""></b-form-input>
          </div>
        </b-form-group>
        <b-col class="col-sm-auto">
          <router-link id="register" :to="{ name: 'register', params: { givenEmail: email } }" class="btn btn-primary btn-lg" tag="button"> {{ $t("lang.label_registerNow") }}</router-link>
        </b-col>
      </b-row>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      email: ""
    };
  }
};
</script>
<style scoped></style>
